import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42d0b32e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "list-group list-group-flush" }
const _hoisted_3 = { class: "list-group-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "card-title mt-1 mb-3" }, "Корзина", -1))
const _hoisted_5 = {
  key: 0,
  class: "list-group-item list-bottom"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Корзина пуста", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "list-group-item list-bottom" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Итого: ")
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CartCardRow = _resolveComponent("CartCardRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "cart-link",
          to: "/cart"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.cartAsArray, (cartItem, idx) => {
        return (_openBlock(), _createBlock(_component_CartCardRow, {
          key: idx,
          cartItem: cartItem
        }, null, 8, ["cartItem"]))
      }), 128)),
      (!_ctx.$store.getters.cartAsArray.length)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.$store.getters.cartTotal), 1)
        ]),
        _createVNode(_component_router_link, {
          class: "cart-link",
          to: "/cart"
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: !_ctx.$store.getters.numberOfItemsInCart
            }, "Оформить", 8, _hoisted_11)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}